import {Injectable} from '@angular/core';

import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError,  mergeMap, switchMap, tap} from 'rxjs/operators';
// import {DipendenteService} from '../../shared/services/dipendente.service';

import {genericActions} from './action-types';
import {NotificationService} from '../../shared/services/notification.service';
import {ProfileService} from "../../services/profile.service";
import {ClientsService} from "../../services/clients.service";
import {AwardService} from "../../services/award.service";
// import {ClientService} from '../../shared/services/client.service';
// import {CompanyService} from '../../shared/services/company.service';
// import {MezziService} from '../../shared/services/mezzi.service';


@Injectable()
export class GeneralEffects {

  loadingProfile$ = createEffect(
    () => this.actions$.pipe(
        ofType(genericActions.loadingProfile),
        mergeMap(() => this.profileService.getMyProfile()),
        switchMap((profile) => {
          if (profile) {
            return [genericActions.loadedProfile({ profile }), genericActions.loadingMyPoints()];

          } else {
            return [genericActions.loadingProfileFailed()];
          }
        }),
        catchError(() => [genericActions.loadingProfileFailed()])
      ),
    { dispatch: true }
  );

  updateProfile$ = createEffect(
    () => this.actions$.pipe(
        ofType(genericActions.updatingProfile),
        mergeMap((action) => this.profileService.saveMyProfile(action.profile)),
        tap(() => this.notificationService.showSuccess('Dati anagrafici aggiornati con successo')),
        switchMap(()=> this.profileService.getMyProfile()),
        switchMap((profile) => ([genericActions.updatedProfile({ profile })])),
        catchError(() => [genericActions.updatingProfileFailed()])
      ), { dispatch: true }
  );

  updateAvatar$ = createEffect(
    () => this.actions$.pipe(
      ofType(genericActions.updatingAvatar),
      mergeMap((action) => this.profileService.saveMyAvatar(action.file)),
      tap(() => this.notificationService.showSuccess('Immagine caricata con successo')),
      switchMap((avatar) => ([genericActions.updatedAvatar({ avatar })])),
      catchError(() => [genericActions.updatingAvatarFailed()])
    ), {dispatch: true}
  );

  loadingClient$ = createEffect(
    () => this.actions$.pipe(
        ofType(genericActions.loadingClient),
        mergeMap(() => this.clientService.getClientInfo()),
        switchMap((client) => {
          if (client) {
            return [genericActions.loadClientCompleted({ client }), genericActions.loadingModules()];
          } else {
            return [genericActions.loadClientFailed()];
          }
        }),
        catchError(() => [genericActions.loadClientFailed()])
      ), { dispatch: true });


  loadingModules$ = createEffect(
    () => this.actions$.pipe(
      ofType(genericActions.loadingModules),
      mergeMap(() => this.clientService.getMyModules()),
      switchMap((modules) => {
        if(modules){
          console.log(modules);
          return [genericActions.loadedModules({modules})]
        }else {
          return [genericActions.loadingModulesFailed()];
        }
      }),
      catchError(() => [genericActions.loadingModulesFailed()])
    ), {dispatch: true}
  )

  loadingMyPoints$ = createEffect(
    () => this.actions$.pipe(
      ofType(genericActions.loadingMyPoints),
      mergeMap(() => this._awardService.getMyPoints()),
      switchMap((points) => {
        if (points) {
          return [genericActions.loadedMyPoints({ myPoints: Math.trunc(points.value) })];
        } else {
          return [genericActions.loadingMyPointsFailed()];
        }
      }),
      catchError(() => [genericActions.loadingMyPointsFailed()])
    ), { dispatch: true });

  constructor(private actions$: Actions,
              private profileService: ProfileService,
              private clientService: ClientsService,
              private _awardService: AwardService,
              private notificationService: NotificationService,
              ) {
  }




}
